import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Giro from './Giro.js';
import ACCESS from '../../../ACCESS.js';

class Giros extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'giro/filter', deleteUrl: 'giro/delete', deleteField: 'giro_nombre', modUrl: '/Catalogo/Giro' },
      TableOp.Table('Giros', [
        { label: 'Clave', id: 'giro' },
        { label: 'Giro', id: 'giro_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_GIROS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_GIROS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
        {
             
          <Giro   onSave={() => {this.table()}}></Giro>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Giros)